<template>
    <apexchart :options="chartOptions" :series="series" type="pie"/>
</template>

<script>
    export default {
        name: "WidgetChart2",
        data() {
            return {
                chartOptions: {
                    chart: {
                        id: 'vuechart-example2',
                        toolbar: {
                            show: false
                        },
                    },
                    plotOptions: {
                        pie: {
                            customScale: 1
                        }
                    },
                    legend: {
                        position: 'bottom',
                        horizontalAlign: 'left',
                        fontSize: '10px',
                    },
                    title: {
                        text: "Общая статистика по заявкам"
                    },
                    labels: ["зарегистрировано", "на рассмотрении", "обработано"],
                    //colors: ["#ff0000", "#00ff00", "#0000ff", "#ff0000", "#00ff00"]
                },
                series: [44, 12, 32],


            }
        },
    }
</script>

<style scoped>

</style>